import { useEffect, useRef, useState } from "react";

const CANVAS_WIDTH = 420;
const CANVAS_HEIGHT = 630;

interface TemplatePreviewProps {
  htmlContent: string;
  className?: string;
  height?: string;
}

const TemplatePreview = ({
  htmlContent,
  className = "",
  height = "600px",
}: TemplatePreviewProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateScale = () => {
      const { width, height: availableHeight } = container.getBoundingClientRect();
      setScale(Math.min(width / CANVAS_WIDTH, availableHeight / CANVAS_HEIGHT));
    };

    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className={`relative w-full overflow-hidden ${className}`}
      style={{ height }}
    >
      <iframe
        title="Access Card Preview"
        srcDoc={htmlContent}
        scrolling="no"
        style={{
          border: "none",
          position: "absolute",
          left: "50%",
          top: "50%",
          width: `${CANVAS_WIDTH}px`,
          height: `${CANVAS_HEIGHT}px`,
          transform: `translate(-50%, -50%) scale(${scale})`,
          transformOrigin: "center",
        }}
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
};

export default TemplatePreview;
